import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11 2a2 2 0 0 0-2 2v1.36a4.033 4.033 0 0 1 2.781-.283c2.263.595 3.552 3.077 2.878 5.544-.674 2.467-2.928 4.975-5.562 4.283a3.415 3.415 0 0 1-1.158-.547 3.415 3.415 0 0 1-1.158.547c-2.633.692-4.887-1.816-5.561-4.283-.674-2.467.614-4.949 2.877-5.544.997-.262 2.017-.114 2.903.344V4c0-.182.012-.361.036-.537-.744.432-1.818.41-2.765-.137C3.18 2.696 2.606 1.567 2.812.608 3.54-.052 4.804-.12 5.897.512c.776.448 1.29 1.147 1.449 1.859A4 4 0 0 1 11 0v2Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconComfortFruit16 = createIcon(IconComponent);